/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Finance_TakingsInputs */

const en_features_finance_takings = /** @type {(inputs: Features_Finance_TakingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken this month`)
};

const pl_features_finance_takings = /** @type {(inputs: Features_Finance_TakingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpływy w tym miesiącu`)
};

/**
* | output |
* | --- |
* | "Taken this month" |
*
* @param {Features_Finance_TakingsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_finance_takings = /** @type {((inputs?: Features_Finance_TakingsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Finance_TakingsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_finance_takings(inputs)
	return en_features_finance_takings(inputs)
});